import React from "react";
import "./aboutus.css";
import aboutusimage from "../../images/cover2.jpg";
export default function Aboutus() {
  return (
    <div className="kingabout">
      <div className="sky">
        <img className="aboutusleft" src={aboutusimage} alt="" />
        <div className="leftright">
          <div className="left1">
            <h1>About us</h1>
            <p>
              Lafema Systems is a team of passionate engineers who have gained
              alot of experience in the telecommunications industry, as well as
              IT industry.
            </p>

            <p>
              Lafema Systems aims to provide secure and safe tracking solutions
              which are paramount to personal and commercial vehicles. These
              solutions combine seamless software and hardware experiences that
              are secure.
            </p>
          </div>
          <div className="right1">
            <div>
              <button className="searchbutt">Search...</button>
              <div className="searchicon"></div>
            </div>
            <div className="line1"></div>
            <div className="linkslinks">Links</div>
            <li className="hommee">Home</li>
          </div>
        </div>
      </div>
      <div className="middle1">
        <p>
          Vehicle tracking removes the blindfold, delivering this critical
          information right to your desktop through an affordable set of
          features. Salama Tracking Solutions vehicle tracking solution provides
          our customers with real-time information about their mobile asset
          anytime / anywhere / all year round Once we have a clear understanding
          of your vision and requirements for success, we use our
          industrial-leading expertise, proven track record of product and
          service excellence, and powerful network of technology partners to
          provide your company with a total business operation solution
        </p>

        <p>
          Having a transport company of our own enables us to understand the
          rate to our client woes giving Salama Tracking Solutions an insight
          needed to provide you with a superior product and service. When it
          comes to fleet and vehicle management, you can’t prove what you can’t
          measure
        </p>
        <p>
          The business challenge is to find the right alliance of technology and
          service to unleash your full potential. That is what our automatic
          tracking report and easy-to-read graphs let you identify operational
          trouble spots and are for fleet improvement at glance.
        </p>
        <h2>Vision</h2>
        <p>
          To be a world-class provider of Vehicle Tracking solutions and Fleet
          Management
        </p>
        <h2>Mission</h2>
        <p>
          To provide leading technology and cost-effective solutions in vehicle
          tracking and fleet management. We are passionately committed to
          quality products and world-class customer experience and service.
        </p>
        <h2>Our services</h2>
      </div>
      <div className="down1">
        <div className="mwanzo">
          <li>Personal car tracking and management</li>
          <li>
            Commercial vehicles tracking (Lorries, semi-truck, motorbike,
            tuk-tuk, buses, and Matatus)
          </li>
        </div>
        <div className="katikati">
          <li>Fleet management services and systems</li>
          <li>History Reports and Vehicle Route Playback</li>
        </div>
        <div className="mwisho">
          <li>Real-time Location Reports</li>
          <li>Driver Identification</li>
        </div>
      </div>
    </div>
  );
}
